<template>
<v-main>
  <v-card
      
    >
        <v-card-title class="headline">Authenticate your callers identity</v-card-title>

        <v-card-subtitle>Voice authentication, SMS, security questions</v-card-subtitle>

        <v-card-text>Identify your callers by voice, SMS verification, or security questions.</v-card-text>

        <v-card-text>Keep a history of caller identification.</v-card-text>

        <v-card-text>
            Your account is not currently setup to use this module.
        </v-card-text>
        
    </v-card>
  
  <br><br>
</v-main>
</template>

<script >
import { mapState } from 'vuex';


export default {
  
  data() {
    return {
      navopen: 1,
      viewMsgGroupId: null,
      viewMsgGroupName: null,
      showNewContact: false,
    };
  },
  computed: {
    ...mapState(['user']),
    groups: {
      get() {
        return this.$store.getters.messageGroups;
      }
    },
    local_uid() { return this.user.user_id },

  },
  components: {
    
  },
  methods: {
    
  },
};
</script>

<style>

</style>
